<script>
let idCounter = 0;
</script>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

import T from './DsFoldableDataCard.i18n.js';

import jQuery from 'jquery';

import DsOptionsMenu from 'JIX/components/ds/DsOptionsMenu.vue';
import SvgIcon from 'JIX/components/SvgIcon.vue';

import 'icons/inline-menuarrow-down.svg';

const props = defineProps({
    id: {
        type: String,
        required: false,
        default: () => 'jix-foldable-data-card--' + (++idCounter),
    },
    menu: {
        type: Object,
        required: false,
        default: null,
    },
    openText: {
        type: String,
        required: false,
        default: T.openTextDefault(),
    },
    closeText: {
        type: String,
        required: false,
        default: T.closeTextDefault(),
    },
});
const emit = defineEmits(['hide', 'show']);

const body = ref();
const collapseObj = ref();
const expanded = ref(false);

const expandLabel = computed(() => expanded.value ? "Luk" : "Fold ud");
const expanderText = computed(() => expanded.value ? props.closeText : props.openText);

function toggleState() {
    collapseObj.value.collapse('toggle');
}
function setState(state) {
    collapseObj.value.collapse(state ? 'show' : 'hide');
}

onMounted(() => {
    collapseObj.value = jQuery(body.value);
    collapseObj.value.collapse({ toggle: false });

    collapseObj.value.on('hide.bs.collapse', () => {
        expanded.value = false;
        emit('hide');
    });
    collapseObj.value.on('show.bs.collapse', () => {
        expanded.value = true;
        emit('show');
    });
});
onBeforeUnmount(() => {
    collapseObj.value.collapse('dispose');
});

defineExpose({
    toggleState,
    setState,
});
</script>

<template>
    <div :class="['foldable-data-card', {'foldable-data-card--expanded': expanded}]">
        <div class="foldable-data-card__header">
            <DsOptionsMenu class="foldable-data-card__menu" v-bind="menu" v-if="menu" />
            <slot name="header" />
            <slot name="subheader" />
        </div>
        <template v-if="$slots.body">
            <div
                class="collapse"
                :id="id + '--body'"
                ref="body"
            >
                <div class="foldable-data-card__body-inner">
                    <slot name="body" />
                </div>
            </div>
            <a
                href="#"
                role="button"
                ref="button"
                aria-expanded="false"
                :aria-controls="id + '--body'"
                :data-target="'#' + id + '--body'"
                data-toggle="collapse"
                class="foldable-data-card__expander"
                :title="expandLabel"
            ><SvgIcon name="inline-menuarrow-down" :aria-label="expanderText" size="mini" /></a>
        </template>
    </div>
</template>
